exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-cube-grid {\n    position: relative;\n    top: 50%;\n    width: 40px;\n    height: 40px;\n    margin: auto;\n}\n\n.sk-cube-grid .sk-cube {\n    width: 33%;\n    height: 33%;\n    float: left;\n    animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;\n}\n\n.sk-cube-grid .sk-cube1 {\n    animation-delay: 0.2s;\n}\n\n.sk-cube-grid .sk-cube2 {\n    animation-delay: 0.3s;\n}\n\n.sk-cube-grid .sk-cube3 {\n    animation-delay: 0.4s;\n}\n\n.sk-cube-grid .sk-cube4 {\n    animation-delay: 0.1s;\n}\n\n.sk-cube-grid .sk-cube5 {\n    animation-delay: 0.2s;\n}\n\n.sk-cube-grid .sk-cube6 {\n    animation-delay: 0.3s;\n}\n\n.sk-cube-grid .sk-cube7 {\n    animation-delay: 0s;\n}\n\n.sk-cube-grid .sk-cube8 {\n    animation-delay: 0.1s;\n}\n\n.sk-cube-grid .sk-cube9 {\n    animation-delay: 0.2s;\n}\n\n@keyframes sk-cubeGridScaleDelay {\n    0%, 70%, 100% {\n        transform: scale3D(1, 1, 1);\n    }\n    35% {\n        transform: scale3D(0, 0, 1);\n    }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Angular projects/memberreg/memberreg/src/app/spinner/spinkit-css/sk-cube-grid.css
// module id = ../../../../../src/app/spinner/spinkit-css/sk-cube-grid.css
// module chunks = main